import * as MuiTab from '@mui/material/Tab'
import React from 'react'

export type TabProps = MuiTab.TabProps

export function Tab({ ...props }: TabProps) {
  return <MuiTab.default {...props} />
}
